import axios from '../utils/AxiosInstance'

export default {
  state: {
  },
  mutations: {
  },
  getters: {
  },
  actions: {
    createMedia ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`guest/questionnaires/${getters.getToken}/media`, data)
      .then((response) => {
        return response.data
      })
    },
    createMediaMultipart ({commit, dispatch, getters, state}, formData) {
      return axios.post(`guest/questionnaires/${getters.getToken}/media/multipart`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((response) => {
        return response.data
      })
    }
  }
}
